import { render, staticRenderFns } from "./LanguageButton.vue?vue&type=template&id=a0fdfd04&scoped=true&"
import script from "./LanguageButton.vue?vue&type=script&lang=ts&"
export * from "./LanguageButton.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageButton.vue?vue&type=style&index=0&id=a0fdfd04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fdfd04",
  null
  
)

export default component.exports